import { ScrollTrigger } from '../global/gsap';
import initSplash from '../components/home/splash';

const splashEl = document.querySelector('.js-splash');

const initGeo = () => {
    // Get current location local storage
    const userContinent = localStorage.getItem('userContinent');

    // If set, don't fetch and init splash
    if (userContinent) {
        document.body.dataset.continent = userContinent;

        if (splashEl) {
            initSplash(splashEl);
        }

        if (userContinent === 'AS' || userContinent === 'OC') {
            const allLinks = document.querySelectorAll('a');

            allLinks.forEach((link) => {
                const trimmed = link.href.replace(/\/$/, '').replace('http://', '').replace('https://', '');
                const segment = trimmed.split('/')[1];

                if (segment === 'projects') {
                    link.href += '?apOrder';
                }
            });
        }

        ScrollTrigger.refresh();
    // Otherwise fetch location and init splash
    } else {
        fetch('https://api.ipregistry.co/?key=ira_JFt0FNiAFWgK3q5Y3xgi6g4WWzUP0G4RRnbn', {
            signal: AbortSignal.timeout(2500)
        }).then((response) => response.json()).then((json) => {
            localStorage.setItem('userContinent', json.location.continent.code);
            document.body.dataset.continent = json.location.continent.code;

            if (splashEl) {
                initSplash(splashEl);
            }

            if (json.location.continent.code === 'AS' || json.location.continent.code === 'OC') {
                const allLinks = document.querySelectorAll('a');

                allLinks.forEach((link) => {
                    const trimmed = link.href.replace(/\/$/, '');
                    const segment = trimmed.substr(trimmed.lastIndexOf('/') + 1);

                    if (segment === 'projects') {
                        link.href += '?apOrder';
                    }
                });
            }

            ScrollTrigger.refresh();
        }).catch((error) => {
            console.warn('Could not retrieve location', error);

            // Fall back to EU
            localStorage.setItem('userContinent', 'EU');
            document.body.dataset.continent = 'EU';

            if (splashEl) {
                initSplash(splashEl);
            }

            ScrollTrigger.refresh();
        });
    }
};

export { initGeo as default };
